import $ from "jquery";

window.jQuery = $;
window.$ = $;



// WEBPACK FOOTER //
// ./assets/scripts/jquery.js